var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.607571 0.322571C0.775176 0.322571 0.942782 0.322555 1.02659 0.490161L5.30051 4.76411C5.55192 5.01552 5.55192 5.35073 5.30051 5.60214L1.02659 9.87609C0.775176 10.1275 0.439965 10.1275 0.188556 9.87609C-0.0628522 9.62468 -0.0628522 9.28947 0.188556 9.03806L4.04347 5.18313L0.188556 1.32819C-0.0628522 1.07678 -0.0628522 0.74157 0.188556 0.490161C0.272359 0.406358 0.439965 0.322571 0.607571 0.322571Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.0c13da9fe5ac0bad30f9c75ecaf12aba.svg";
export { ForwardRef as ReactComponent };